import { j as o } from "../../jsx-runtime-ClSzPYp4.js";
import e from "../BaseIcon.mjs";
const i = (s) => /* @__PURE__ */ o.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Shield",
  ...s,
  children: /* @__PURE__ */ o.jsx("g", {
    children: /* @__PURE__ */ o.jsx("path", {
      d: "M21.98 4.67c-3.04-.09-6.99-1.75-10-3.67-3.14 1.96-7.09 3.67-9.96 3.67 0 0-1 14.3 9.96 18.33 10.99-4.03 10-18.33 10-18.33z"
    })
  })
}), a = (s) => /* @__PURE__ */ o.jsx(e, {
  IconSvg: i,
  ...s
});
export {
  a as default
};
